import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "라이브러리 게시",
  "description": "모노레포에서 npm 레지스트리에 라이브러리를 게시하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "적절한 도구를 사용하면 모노레포에서 npm 레지스트리에 패키지를 게시하는 것이 원활한 경험이 될 수 있습니다."
  }, {
    "heading": "",
    "content": "이 가이드는 견고한 패키지에 필요한 모든 가능한 컴파일, 번들링 및 게시 설정을 해결할 수는 없지만 몇 가지 기본 사항을 설명합니다."
  }, {
    "heading": "",
    "content": "모노레포의 일부 패키지를 npm에 게시하려는 경우 이 설정을 따라야 합니다. npm에\n게시할 필요가 없다면 Internal\nPackage를\n사용해야 합니다. 설정 및 사용이 훨씬 쉽습니다."
  }, {
    "heading": "번들링",
    "content": "Internal Packages와 달리 외부 패키지는 npm에 배포하고 로컬에서 사용할 수 있습니다. 이 가이드에서는 npm에서 가장 일반적으로 사용되는 형식인 ECMAScript modules(esm)과 CommonJS modules(cjs) 모두에 패키지를 번들링합니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "Internal Packages 튜토리얼을 사용하여 생성된 패키지부터 시작하겠습니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "거기서 숫자를 더하고 빼는 몇 가지 도우미 함수가 포함된 @repo/math 패키지를 만들었습니다. 이 패키지가 npm에 충분히 좋다고 판단하여 번들링할 것입니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "번들러를 사용하여 @repo/math에 build 스크립트를 추가할 것입니다. 어떤 것을 선택해야 할지 모르겠다면 tsup를 권장합니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "패키지 매니저를 사용하여 ./packages/math 패키지 내에 tsup를 설치한 다음 빌드 스크립트를 만듭니다:"
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "tsup는 기본적으로 dist 디렉토리에 파일을 출력하므로 다음을 수행해야 합니다:"
  }, {
    "heading": "빌드-스크립트-설정",
    "content": ".gitignore 파일에 dist를 추가하여 소스 제어에 커밋되지 않도록 합니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "turbo.json의 build outputs에 dist를 추가합니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "이렇게 하면 tsup가 실행될 때 출력이 Turborepo에 의해 캐시될 수 있습니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "마지막으로 패키지 진입점을 업데이트해야 합니다. package.json 내에서 CommonJS modules(cjs)를 사용하는 클라이언트를 위해 main을 ./dist/index.js로, ECMAScript modules(esm)를 사용하는 클라이언트를 위해 module을 ./dist/index.mjs로, 타입 정의 파일인 ./dist/index.d.ts를 위해 types를 변경합니다:"
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "cjs와 esm 모두에 번들링할 필요는 없습니다. 그러나 권장되는데, 이를 통해 패키지를 다양한 환경에서 사용할 수 있습니다."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "main, module 및 types를 사용하여 오류가 발생하면 tsup docs를 참조하세요."
  }, {
    "heading": "빌드-스크립트-설정",
    "content": "번들링은 복잡한 주제이며 여기서 모든 것을 다룰 공간이 없습니다!"
  }, {
    "heading": "앱-전에-패키지-빌드",
    "content": "turbo run build를 실행하기 전에 고려해야 할 사항이 하나 있습니다. 모노레포에 작업 종속성을 추가했습니다. packages/math의 build는 apps/web의 build 전에 실행되어야 합니다."
  }, {
    "heading": "앱-전에-패키지-빌드",
    "content": "다행히도 dependsOn을 사용하여 이를 쉽게 설정할 수 있습니다."
  }, {
    "heading": "앱-전에-패키지-빌드",
    "content": "이제 turbo run build를 실행하면 앱을 빌드하기 전에 패키지를 자동으로 빌드합니다."
  }, {
    "heading": "dev-스크립트-설정",
    "content": "설정에 작은 문제가 있습니다. 패키지를 잘 빌드하고 있지만 개발에서 제대로 작동하지 않습니다. @repo/math 패키지에 대한 변경 사항이 앱에 반영되지 않습니다."
  }, {
    "heading": "dev-스크립트-설정",
    "content": "작업하는 동안 패키지를 다시 빌드할 dev 스크립트가 없기 때문입니다. 쉽게 추가할 수 있습니다:"
  }, {
    "heading": "dev-스크립트-설정",
    "content": "이렇게 하면 --watch 플래그가 tsup에 전달되어 파일 변경 사항을 감시합니다."
  }, {
    "heading": "dev-스크립트-설정",
    "content": "turbo.json에서 이미 dev scripts를 설정한 경우 turbo run dev를 실행하면 packages/math dev 작업이 apps/web dev 작업과 병렬로 실행됩니다."
  }, {
    "heading": "dev-스크립트-설정",
    "content": "이제 패키지가 npm에 배포할 수 있는 상태입니다. 버전 관리 및 게시 섹션에서 바로 그렇게 할 것입니다."
  }, {
    "heading": "버전-관리-및-게시",
    "content": "모노레포에서 패키지를 수동으로 버전 관리하고 게시하는 것은 지루할 수 있습니다. 다행히도 작업을 쉽게 만드는 도구가 있습니다 - Changesets CLI입니다."
  }, {
    "heading": "버전-관리-및-게시",
    "content": "Changesets는 직관적으로 사용할 수 있고 Turborepo처럼 이미 익숙한 모노레포 도구와 잘 맞기 때문에 권장합니다."
  }, {
    "heading": "버전-관리-및-게시",
    "content": "몇 가지 대안은 다음과 같습니다:"
  }, {
    "heading": "버전-관리-및-게시",
    "content": "intuit/auto - 풀 리퀘스트의 시맨틱 버전 레이블을 기반으로 릴리스 생성"
  }, {
    "heading": "버전-관리-및-게시",
    "content": "microsoft/beachball - The Sunniest Semantic Version Bumper"
  }, {
    "heading": "게시",
    "content": "패키지가 번들링되면 npm 레지스트리에 게시할 수 있습니다."
  }, {
    "heading": "게시",
    "content": "Changesets 문서를 살펴보는 것을 권장합니다. 다음은 권장 읽기 순서입니다:"
  }, {
    "heading": "게시",
    "content": "Why use changesets? - 기본 사항을 안내하는 소개"
  }, {
    "heading": "게시",
    "content": "Installation instructions"
  }, {
    "heading": "게시",
    "content": "GitHub를 사용하는 경우 Changeset GitHub bot 사용을 고려하세요 - PR에 changesets을 추가하도록 유도하는 봇입니다."
  }, {
    "heading": "게시",
    "content": "Changesets GitHub action 추가도 고려해야 합니다 - 게시를 매우 쉽게 만드는 도구입니다."
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "Changesets 사용을 시작하면 세 가지 유용한 명령에 액세스할 수 있습니다:"
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "게시 플로우를 Turborepo에 연결하면 배포를 훨씬 간단하고 빠르게 구성할 수 있습니다."
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "Changesets가 changeset version의 변경 사항을 자동으로 커밋하도록 설정하는 것이 좋습니다."
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "그리고 루트 package.json에 publish-packages 스크립트를 추가합니다:"
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "패키지가 public인 경우 Changeset의 access를 public으로 설정합니다:"
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "npm의 내장 publish 스크립트와 충돌하지 않도록 publish-packages를\n권장합니다."
  }, {
    "heading": "turborepo와-함께-changesets-사용",
    "content": "즉, publish-packages를 실행하면 모노레포가 빌드, 린팅, 테스트 및 게시되며 Turborepo의 모든 속도 향상 혜택을 받을 수 있습니다."
  }],
  "headings": [{
    "id": "번들링",
    "content": "번들링"
  }, {
    "id": "빌드-스크립트-설정",
    "content": "빌드 스크립트 설정"
  }, {
    "id": "앱-전에-패키지-빌드",
    "content": "앱 전에 패키지 빌드"
  }, {
    "id": "dev-스크립트-설정",
    "content": "dev 스크립트 설정"
  }, {
    "id": "버전-관리-및-게시",
    "content": "버전 관리 및 게시"
  }, {
    "id": "게시",
    "content": "게시"
  }, {
    "id": "turborepo와-함께-changesets-사용",
    "content": "Turborepo와 함께 Changesets 사용"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from '#components/tabs';
export const toc = [{
  depth: 2,
  url: "#번들링",
  title: _jsx(_Fragment, {
    children: "번들링"
  })
}, {
  depth: 2,
  url: "#빌드-스크립트-설정",
  title: _jsx(_Fragment, {
    children: "빌드 스크립트 설정"
  })
}, {
  depth: 3,
  url: "#앱-전에-패키지-빌드",
  title: _jsx(_Fragment, {
    children: "앱 전에 패키지 빌드"
  })
}, {
  depth: 3,
  url: "#dev-스크립트-설정",
  title: _jsx(_Fragment, {
    children: "dev 스크립트 설정"
  })
}, {
  depth: 2,
  url: "#버전-관리-및-게시",
  title: _jsx(_Fragment, {
    children: "버전 관리 및 게시"
  })
}, {
  depth: 2,
  url: "#게시",
  title: _jsx(_Fragment, {
    children: "게시"
  })
}, {
  depth: 2,
  url: "#turborepo와-함께-changesets-사용",
  title: _jsx(_Fragment, {
    children: "Turborepo와 함께 Changesets 사용"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "적절한 도구를 사용하면 모노레포에서 npm 레지스트리에 패키지를 게시하는 것이 원활한 경험이 될 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "이 가이드는 견고한 패키지에 필요한 모든 가능한 컴파일, 번들링 및 게시 설정을 해결할 수는 없지만 몇 가지 기본 사항을 설명합니다."
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["모노레포의 일부 패키지를 npm에 게시하려는 경우 이 설정을 따라야 합니다. npm에\n게시할 필요가 없다면 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/creating-an-internal-package",
          children: "Internal\nPackage"
        }), "를\n사용해야 합니다. 설정 및 사용이 훨씬 쉽습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "번들링",
      children: "번들링"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Internal Packages"
      }), "와 달리 외부 패키지는 ", _jsx(_components.a, {
        href: "https://www.npmjs.com",
        children: "npm"
      }), "에 배포", _jsx(_components.em, {
        children: "하고"
      }), " 로컬에서 사용할 수 있습니다. 이 가이드에서는 npm에서 가장 일반적으로 사용되는 형식인 ", _jsx(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Modules",
        children: "ECMAScript modules"
      }), "(", _jsx(_components.code, {
        children: "esm"
      }), ")과 ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/CommonJS",
        children: "CommonJS modules"
      }), "(", _jsx(_components.code, {
        children: "cjs"
      }), ") 모두에 패키지를 번들링합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "빌드-스크립트-설정",
      children: "빌드 스크립트 설정"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Internal Packages"
      }), " 튜토리얼을 사용하여 생성된 패키지부터 시작하겠습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["거기서 숫자를 더하고 빼는 몇 가지 도우미 함수가 포함된 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 패키지를 만들었습니다. 이 패키지가 npm에 충분히 좋다고 판단하여 번들링할 것입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["번들러를 사용하여 ", _jsx(_components.code, {
        children: "@repo/math"
      }), "에 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트를 추가할 것입니다. 어떤 것을 선택해야 할지 모르겠다면 ", _jsx(_components.a, {
        href: "https://tsup.egoist.dev/",
        children: _jsx(_components.code, {
          children: "tsup"
        })
      }), "를 권장합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["패키지 매니저를 사용하여 ", _jsx(_components.code, {
        children: "./packages/math"
      }), " 패키지 내에 ", _jsx(_components.code, {
        children: "tsup"
      }), "를 설치한 다음 빌드 스크립트를 만듭니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tsup"
      }), "는 기본적으로 ", _jsx(_components.code, {
        children: "dist"
      }), " 디렉토리에 파일을 출력하므로 다음을 수행해야 합니다:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".gitignore"
        }), " 파일에 ", _jsx(_components.code, {
          children: "dist"
        }), "를 추가하여 소스 제어에 커밋되지 않도록 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "의 ", _jsx(_components.code, {
          children: "build"
        }), " outputs에 ", _jsx(_components.code, {
          children: "dist"
        }), "를 추가합니다."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이렇게 하면 ", _jsx(_components.code, {
        children: "tsup"
      }), "가 실행될 때 출력이 Turborepo에 의해 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "캐시"
      }), "될 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["마지막으로 패키지 진입점을 업데이트해야 합니다. ", _jsx(_components.code, {
        children: "package.json"
      }), " 내에서 CommonJS modules(", _jsx(_components.code, {
        children: "cjs"
      }), ")를 사용하는 클라이언트를 위해 ", _jsx(_components.code, {
        children: "main"
      }), "을 ", _jsx(_components.code, {
        children: "./dist/index.js"
      }), "로, ECMAScript modules(", _jsx(_components.code, {
        children: "esm"
      }), ")를 사용하는 클라이언트를 위해 ", _jsx(_components.code, {
        children: "module"
      }), "을 ", _jsx(_components.code, {
        children: "./dist/index.mjs"
      }), "로, 타입 정의 파일인 ", _jsx(_components.code, {
        children: "./dist/index.d.ts"
      }), "를 위해 ", _jsx(_components.code, {
        children: "types"
      }), "를 변경합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"main\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.js\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"module\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.mjs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.d.ts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "cjs"
        }), "와 ", _jsx(_components.code, {
          children: "esm"
        }), " 모두에 번들링할 필요는 없습니다. 그러나 권장되는데, 이를 통해 패키지를 다양한 환경에서 사용할 수 있습니다."]
      }), _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "main"
        }), ", ", _jsx(_components.code, {
          children: "module"
        }), " 및 ", _jsx(_components.code, {
          children: "types"
        }), "를 사용하여 오류가 발생하면 ", _jsx(_components.a, {
          href: "https://tsup.egoist.dev/#bundle-formats",
          children: "tsup docs"
        }), "를 참조하세요."]
      }), _jsx(_components.p, {
        children: "번들링은 복잡한 주제이며 여기서 모든 것을 다룰 공간이 없습니다!"
      })]
    }), "\n", _jsx(_components.h3, {
      id: "앱-전에-패키지-빌드",
      children: "앱 전에 패키지 빌드"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행하기 전에 고려해야 할 사항이 하나 있습니다. 모노레포에 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "작업 종속성"
      }), "을 추가했습니다. ", _jsx(_components.code, {
        children: "packages/math"
      }), "의 ", _jsx(_components.code, {
        children: "build"
      }), "는 ", _jsx(_components.code, {
        children: "apps/web"
      }), "의 ", _jsx(_components.code, {
        children: "build"
      }), " ", _jsx(_components.strong, {
        children: "전에"
      }), " 실행되어야 합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["다행히도 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: _jsx(_components.code, {
          children: "dependsOn"
        })
      }), "을 사용하여 이를 쉽게 설정할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행하면 앱을 빌드하기 ", _jsx(_components.em, {
        children: "전에"
      }), " 패키지를 자동으로 빌드합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "dev-스크립트-설정",
      children: "dev 스크립트 설정"
    }), "\n", _jsxs(_components.p, {
      children: ["설정에 작은 문제가 있습니다. 패키지를 잘 빌드하고 있지만 개발에서 제대로 작동하지 않습니다. ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 패키지에 대한 변경 사항이 앱에 반영되지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["작업하는 동안 패키지를 다시 빌드할 ", _jsx(_components.code, {
        children: "dev"
      }), " 스크립트가 없기 때문입니다. 쉽게 추가할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              className: "highlighted-word",
              children: "--watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이렇게 하면 ", _jsx(_components.code, {
        children: "--watch"
      }), " 플래그가 ", _jsx(_components.code, {
        children: "tsup"
      }), "에 전달되어 파일 변경 사항을 감시합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에서 이미 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#configuring-development-tasks",
        children: "dev scripts"
      }), "를 설정한 경우 ", _jsx(_components.code, {
        children: "turbo run dev"
      }), "를 실행하면 ", _jsx(_components.code, {
        children: "packages/math"
      }), " dev 작업이 ", _jsx(_components.code, {
        children: "apps/web"
      }), " dev 작업과 병렬로 실행됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 패키지가 npm에 배포할 수 있는 상태입니다. ", _jsx(_components.a, {
        href: "#versioning-and-publishing",
        children: "버전 관리 및 게시"
      }), " 섹션에서 바로 그렇게 할 것입니다."]
    }), "\n", _jsx(_components.h2, {
      id: "버전-관리-및-게시",
      children: "버전 관리 및 게시"
    }), "\n", _jsxs(_components.p, {
      children: ["모노레포에서 패키지를 수동으로 버전 관리하고 게시하는 것은 지루할 수 있습니다. 다행히도 작업을 쉽게 만드는 도구가 있습니다 - ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: "Changesets"
      }), " CLI입니다."]
    }), "\n", _jsx(_components.p, {
      children: "Changesets는 직관적으로 사용할 수 있고 Turborepo처럼 이미 익숙한 모노레포 도구와 잘 맞기 때문에 권장합니다."
    }), "\n", _jsx(_components.p, {
      children: "몇 가지 대안은 다음과 같습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/intuit/auto",
          children: "intuit/auto"
        }), " - 풀 리퀘스트의 시맨틱 버전 레이블을 기반으로 릴리스 생성"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/microsoft/beachball",
          children: "microsoft/beachball"
        }), " - The Sunniest Semantic Version Bumper"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "게시",
      children: "게시"
    }), "\n", _jsx(_components.p, {
      children: "패키지가 번들링되면 npm 레지스트리에 게시할 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "Changesets 문서를 살펴보는 것을 권장합니다. 다음은 권장 읽기 순서입니다:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/changesets/changesets/blob/main/docs/intro-to-using-changesets.md",
          children: "Why use changesets?"
        }), " - 기본 사항을 안내하는 소개"]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/changesets/changesets/blob/main/packages/cli/README.md",
          children: "Installation instructions"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["GitHub를 사용하는 경우 ", _jsx(_components.a, {
          href: "https://github.com/apps/changeset-bot",
          children: "Changeset GitHub bot"
        }), " 사용을 고려하세요 - PR에 changesets을 추가하도록 유도하는 봇입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/changesets/action",
          children: "Changesets GitHub action"
        }), " 추가도 고려해야 합니다 - 게시를 매우 쉽게 만드는 도구입니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "turborepo와-함께-changesets-사용",
      children: "Turborepo와 함께 Changesets 사용"
    }), "\n", _jsx(_components.p, {
      children: "Changesets 사용을 시작하면 세 가지 유용한 명령에 액세스할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 새 changeset 추가"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 패키지의 새 버전 생성"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " version"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 변경된 모든 패키지를 npm에 게시"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " publish"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "게시 플로우를 Turborepo에 연결하면 배포를 훨씬 간단하고 빠르게 구성할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["Changesets가 ", _jsx(_components.code, {
        children: "changeset version"
      }), "의 변경 사항을 자동으로 커밋하도록 설정하는 것이 좋습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./.changeset/config.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"commit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["그리고 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "에 ", _jsx(_components.code, {
        children: "publish-packages"
      }), " 스크립트를 추가합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // 게시 전에 실행해야 하는 모든 것 포함 - build, lint, test"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"publish-packages\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build lint test && changeset version && changeset publish\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["패키지가 public인 경우 Changeset의 ", _jsx(_components.code, {
        children: "access"
      }), "를 ", _jsx(_components.code, {
        children: "public"
      }), "으로 설정합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./.changeset/config.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"access\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"public\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: ["npm의 내장 ", _jsx(_components.code, {
          children: "publish"
        }), " 스크립트와 충돌하지 않도록 ", _jsx(_components.code, {
          children: "publish-packages"
        }), "를\n권장합니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["즉, ", _jsx(_components.code, {
        children: "publish-packages"
      }), "를 실행하면 모노레포가 빌드, 린팅, 테스트 및 게시되며 Turborepo의 모든 속도 향상 혜택을 받을 수 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
